import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\courses\\page.tsx");
